<template>
  <div class="filter">
    <div v-if="isOpen" class="background-click" @click="close" />
    <div v-if="filterType === 'checkbox'" class="filter-box" @click.stop>
      <div class="touch-place" @click="isOpen = !isOpen">
        <div class="title">
          {{ title }}
        </div>
        <div class="icon-place" :class="{'opened': isOpen}">
          <img :src="filterArrow" alt="">
        </div>
      </div>
      <div class="select-wrapper">
        <template v-if="filterType === 'checkbox' && selectedBoxes.length">
          <span
            v-for="(value, index) in selectedBoxes"
            v-show="getItemTitle(value)"
            :key="index"
            class="selected-item"
          >
            {{ getItemTitle(value) }}
            <img :src="imgClose" @click.stop="removeSelected(value)" />
          </span>
        </template>
        <template v-if="filterType === 'radio' && selectedRadio">
          <span class="selected-item">
            {{ getItemTitle(selectedRadio) }}
          </span>
        </template>
      </div>

      <div v-show="isOpen" class="filter-window">
        <div class="top-part">
          <div class="title">
            Выберите {{ title }}
          </div>
          <div class="image-close" @click="close">
            <img :src="imgClose" />
          </div>
        </div>
        <div class="search-place">
          <n-input v-model="search" placeholder="Поиск" />
        </div>
        <div class="wrapper">
          <div class="boxes">
            <div v-for="(item, index) in filteredValues" :key="index" class="item" @click="addBox(item)">
              <div class="box">
                <img v-if="isSelected(item)" :src="imgChecked" alt="">
              </div>
              <div class="title">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="submit-button">
          <n-button class="default clean" @click="close()">Отменить</n-button>
          <n-button class="default" @click="close()">Подтвердить</n-button>
        </div>
      </div>
    </div>
    <div v-if="filterType === 'radio'" class="filter-box" @click.stop>
      <div class="touch-place" @click="isOpen = !isOpen">
        <div class="title">
          {{ title }}
        </div>
        <div class="icon-place" :class="{'opened': isOpen}">
          <img :src="filterArrow" alt="">
        </div>
      </div>
      <div v-show="isOpen" class="filter-window">
        <div class="search-place">
          <n-input v-model="search" placeholder="Поиск" />
        </div>
        <div class="wrapper">
          <div class="boxes">
            <div v-for="(item, index) in filteredValues" :key="index" class="item" @click="selectedRadio = item[returnField]">
              <div class="circle">
                <div v-show="selectedRadio === item[returnField]" class="circle-fill" />
              </div>
              <div class="title">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-button">
        <n-button class="default clean" @click="close()">Отменить</n-button>
        <n-button class="default" @click="close()">Подтвердить</n-button>
      </div>
    </div>
  </div>
</template>

<script>

import filterArrow from '../../assets/new/arrow-icon.svg'
import imgChecked from '../../assets/new/checkbox-icon.svg'
import imgClose from '../../assets/new/close-icon.svg'


export default {
  name: 'CFilter',
  props: {
    filter: {
      type: [ Array, String, Number, ],
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      required: true,
    },
    returnField: {
      type: String,
      required: true,
    },
    filterType: {
      type: String,
      default: 'checkbox',
    },
    preselected: {
      default: null,
    },
  },
  data() {
    return {
      filterArrow,
      imgChecked,
      imgClose,
      isOpen: false,
      percent: 0,
      search: '',
      selectedBoxes: [],
      selectedRadio: null,
    }
  },
  computed: {
    filteredValues() {
      if (!this.search) {
        return this.items
      }
      const lowerSearch = this.search.toLowerCase().trim()

      return $n.filter(this.items, ((item) =>
        item.title.toLowerCase().includes(lowerSearch)
      )) 
    },
  },
  watch: {
    preselected() {
      if (this.preselected !== null) {
        if (this.filterType === 'checkbox') {
          this.selectedBoxes = this.preselected
        } else {
          this.selectedRadio = this.preselected
        }
      }
    },
    filter: {
      immediate: true,
      handler(val) {
        if (this.filterType === 'checkbox') {
          this.selectedBoxes = Array.isArray(val) ? val : []
        } else {
          this.selectedRadio = val
        }
      },
    },
  },
  mounted() {
    if (this.preselected !== null) {
      if (this.filterType === 'checkbox') {
        this.selectedBoxes = this.preselected
      } else {
        this.selectedRadio = this.preselected
      }
    }
  },
  methods: {
    getItemTitle(value) {
      const found = this.items.find((item) => item[this.returnField] === value)
      return found ? found.title : ''
    },
    removeSelected(value) {
      this.selectedBoxes = this.selectedBoxes.filter((v) => v !== value)
      this.$emit('update:filter', this.selectedBoxes)
    },
    close() {
      this.isOpen = false
      this.search = ''
      this.$emit('load')
    },
    done(value) {
      this.$emit('update:filter', value)
      this.close()
    },
    isSelected(e) {
      return this.selectedBoxes.includes(e[this.returnField])
    },
    addBox(addE) {
      const value = addE[this.returnField]
      const alreadySelected = this.selectedBoxes.includes(value)

      if (!alreadySelected) {
        this.selectedBoxes.push(value)
      } else {
        this.selectedBoxes = this.selectedBoxes.filter((v) => v !== value)
      }

      this.$emit('update:filter', this.selectedBoxes) // ⬅️ главное
    },
  },
}
</script>

<style lang="scss" scoped>
.filter {

  .submit-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .default {
      margin-bottom: 5px;
      min-width: 160px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 700;
      color: #ffffff;
      height: 38px;
      background-color: var(--primary);
      border-radius: 12px;
      border: 1px solid var(--primary);
      &.clean {
        background-color: #ffffff;
        color: var(--primary);
      }
    }
  }
  &.active {
    z-index: 1000;
  }
  .background-click {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1000;
  }
  .select-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
    margin-bottom: 10px;

    .selected-item {
      background: #fff;
      border: 2px solid var(--primary);
      font-size: 12px;
      height: 40px;
      padding: 0 8px;
      border-radius: 12px;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        margin-left: 15px;
      }
    }
  }

  .filter-box {
    cursor: pointer;
    position: relative;
    border-radius: 12px;
    min-width: 200px;

    .touch-place {

      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title {
      font-size: 18px;
      font-weight: 500;
    }
    .icon-place {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s;
      &.opened {
        transform: rotate(180deg);
      }
    }
    .search-place {
      margin-top: 8px;
      :deep() {
        .n-input {
          font-size: 12px;

          .n-content {
            background-color: #F2F4F8;
            height: 48px;
          }
        }
      }
    }

    .filter-window {
      filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.3));
      background-color: #FFFFFF;
      right: -15px;
      left: 50%;
      top: calc(100% - 20px);
      transform: translate(-50%, -50%);
      z-index: 100000;
      padding: 20px 20px 20px 20px;
      position: absolute;
      border-radius: 12px;
      min-width: 400px;

      .top-part {
        display: flex;
        align-items: center;
        justify-content: space-between;


        .title {
          font-size: 16px;
          font-weight: bold;
          color: #000;
        }
      }

      .wrapper {
        padding: 10px;

        .buttons {
          margin-top: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .submit {
            margin-bottom: 5px;
            cursor: pointer;
            min-width: 160px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 700;
            color: #FFFFFF;
            min-height: 30px;
            background-color: var(--primary);
            border-radius: 24px;
          }
          .clean {
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
            color: #000000;
            text-decoration: underline;
          }
        }
        .item {
          display: flex;
          align-items: center;
          margin-top: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #E7EDFF;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .title {
          font-size: 12px;
          color: #000000;
        }
        .boxes {
          overflow: auto;
          max-height: 300px;
          .circle {
            flex-shrink: 0;
            margin-right: 8px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #D9D9D9;
            display: flex;
            align-items: center;
            justify-content: center;
            .circle-fill {
              flex-shrink: 0;
              width: 14px;
              height: 14px;
              border-radius: 50%;
              background-color: var(--primary);
            }
          }
          .box {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            border-radius: 4px;
            border: 1px solid var(--primary);
            margin-right: 8px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
  }
}
</style>
